import { Button, LearnMoreLink, Text } from '@ui/themed';
import type { ReactNode } from 'react';

export function SettingActionRow({
  label,
  description,
  learnMoreUrl,
  actionLabel,
  onAction,
  disabled = false,
  tooltip,
}: {
  label: ReactNode;
  description?: ReactNode;
  learnMoreUrl?: string;
  actionLabel: string;
  onAction: () => void;
  disabled?: boolean;
  tooltip?: string;
}) {
  return (
    <div title={tooltip} className="flex items-center justify-between gap-4">
      <div className="flex min-w-0 flex-1 flex-col">
        <Text>{label}</Text>
        {(description || learnMoreUrl) && (
          <Text size="sm" variant="secondary">
            {description}
            {learnMoreUrl && (
              <>
                {' '}
                <LearnMoreLink link={learnMoreUrl} />
              </>
            )}
          </Text>
        )}
      </div>
      <Button variant="secondary" onClick={onAction} disabled={disabled}>
        {actionLabel}
      </Button>
    </div>
  );
}
